import axiosInstance from "../axiosInterceptor";

export async function getReferenceStyle() {
  const response = await axiosInstance.get(`admin/refStyle/getAllRefStyle`);
  const data = response?.data;
  return data;
}
